import styled, { css } from 'styled-components';
import AddressInput from 'js/components/common/AddressInput';

const flatInputStyle = css`
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
`;

export default styled(AddressInput)`
  ${({ flat }) => flat && flatInputStyle}
`;
